export const CustomCurrencyFormat = (number: number, currency: string) =>
{
    // Hay que manejar casos donde el number o currency pueden ser null/undefined
    // Suponemos que la divisa por defecto es EUR
    if(number === null || number === undefined || isNaN(number))
    {
        return '0,00 ' + (currency || 'EUR');
    }

    if(!currency)
    {
        currency = 'EUR';
    }

    const parts = number.toFixed(2).split('.');
    const integerPart = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.'); // Separador de miles con puntos
    const decimalPart = parts[1]; // Decimales
    return `${integerPart},${decimalPart} ${currency}`;
}